const METRIC_INFO_BODIES = {
  SRA: 'A signature that reached Sunrun Approval',
  CAP: 'Completed final design / closed CAP',
  IC: 'Installation complete',
} as const;

export { METRIC_INFO_BODIES };
